<template>
  <ListingLayout
    :is-loading="isLoading"
    :meta="meta"
    :headers="headers"
    :items="list"
    no-filters
    :filter-names="[]"
    @filterOption="onFiltersChange"
    @clickOnRow="whenRowSelect"
  >
    <template v-slot:vehicle_reg_no="{ item }">
      <div>
        {{ item.vehicle_reg_no || "-" }}
      </div>
    </template>
    <template v-slot:duration="{ item }">
      <div>
        {{ item.charge_session?.duration || "-" }}
      </div>
    </template>
    <template v-slot:energy="{ item }">
      <div>
        {{ item.charge_session?.energy_consumed || "-" }}
      </div>
    </template>
    <template v-slot:revenue="{ item }">
      <div>
        {{ item.charge_session?.energy_cost || "-" }}
      </div>
    </template>
    <template v-slot:booking_status="{ item }">
      <div>
        <status-badge
          :status="item.booking_status"
          :text="item.booking_status"
        />
      </div>
    </template>
    <!-- asdadasd
  <v-data-table
    :loading="isLoading"
    :headers="headers"
    :items="list"
    :items-per-page="5"
  /> -->
  </ListingLayout>
</template>

<script>
import { ListingLayoutMixins } from "@/mixins/ListingLayoutMixins";
import { mapGetters } from "vuex";
export default {
  components: {
    ListingLayout: () => import("@/layouts/section/ListingLayout.vue"),
    StatusBadge: () => import("@/components/base/Status-Badge.vue"),
  },
  mixins: [ListingLayoutMixins],
  data() {
    return {
      headers: [
        {
          text: "Booking Id",
          align: "start",
          sortable: true,
          value: "booking_id",
        },
        {
          text: "Customer Name",
          align: "start",
          sortable: false,
          value: "customer_name",
        },
        {
          text: "Email",
          align: "start",
          sortable: false,
          value: "customer_email",
        },
        {
          text: "Vehicle Reg",
          align: "start",
          sortable: false,
          value: "vehicle_reg_no",
        },
        {
          text: "Station",
          align: "start",
          sortable: false,
          value: "location_name",
        },
        {
          text: "Date",
          align: "start",
          sortable: true,
          value: "booking_date",
        },
        {
          text: "Time",
          align: "start",
          sortable: true,
          value: "start_time_format",
        },
        {
          text: "Duration",
          align: "start",
          sortable: true,
          value: "duration",
        },
        {
          text: "Energy",
          align: "start",
          sortable: true,
          value: "energy",
        },
        {
          text: "Revenue",
          align: "start",
          sortable: false,
          value: "revenue",
        },
        {
          text: "Status",
          align: "start",
          sortable: true,
          value: "booking_status",
        },
        // {
        //   text: "Actions",
        //   align: "start",
        //   sortable: false,
        //   value: "user",
        // },
      ],
    };
  },
  computed: {
    ...mapGetters({
      authUser: "getUser",
      isLoading: "csmsBookings/getLoading",
      list: "csmsBookings/getList",
    }),
    meta() {
      return {
        page: 1,
        itemsPerPage: 10000,
        lastPage: 1,
        totalItems: this.list?.length,
      };
    },
  },
  methods: {
    whenRowSelect(v) {
      this.$emit("clickOnRow", v);
    },
  },
};
</script>
